/**
 * ArticlesContext — now a thin wrapper around TanStack Query.
 *
 * No React Context is used. Each component that calls useArticles()
 * subscribes directly to the TanStack Query cache, so only components
 * whose data actually changed will re-render.
 *
 * The ArticlesProvider is kept as a no-op wrapper for backwards
 * compatibility with App.tsx — it simply renders children.
 */
import type { ReactNode } from "react";
import { useSanityArticles } from "@/hooks/useSanityArticles";
import type { Article } from "@/components/NewsSection";

interface ArticlesResult {
  articles: Article[];
  isLoading: boolean;
}

/** Direct TanStack Query hook — no Context, no re-render cascade */
export function useArticles(): ArticlesResult {
  const { data, isLoading } = useSanityArticles();
  return {
    articles: data ?? [],
    isLoading,
  };
}

/** No-op provider kept for tree compatibility — remove when convenient */
export function ArticlesProvider({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
